// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"856":"70eeffbd","952":"e58c90df"}[chunkId] + ".chunk.js";
};